import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";

import { DatePicker } from "antd";
import Loading from "../../loader/loader.js";
import NkHeader from "../../../common/nkheader";
import NkTable from "../nktable";
import React from "react";
import StatusSelect from "./statusSelect";
import moment from "moment";

const AllUsersPresentational = ({
  searchBy,
  setSearchByValue,
  setSearchBy,
  searchByValuePlaceholder,
  searchByValue,
  fromDate = null,
  setFromDate,
  toDate,
  setToDate,
  setModalShow,
  filtersSelected,
  noOfFiltersSelected,
  resetFilter,
  handleFIlter,
  filterValues,
  allUserList,
  dataLoading,
  buttonRef,
  filterForm,
  onExcelClciked,
  allUserListExcel,
  columns,
  columnsCsv,
  pagination,
  setFilterForm,
  setSizeShow,
  modalShow,
  handleChange,
  options,
  selectedOption,
  rowOnClick,
  statusFilter,
  selectedChannelOption,
  channelOptions,
  handleChannelChange,
}) => {
  const dateFormat = "DD-MM-YY";

  const customFormat = (value) => `${value.format(dateFormat)}`;

  return (
    <>
      <Container fluid>
        <NkHeader title="Registered Users" />
        <Card>
          <CardBody>
            <Row>
              <Col lg="2" className="form-input-padding">
                <FormGroup>
                  <label
                    className="form-control-label"
                    htmlFor="exampleFormControlSelect1"
                  >
                    Search by
                  </label>
                  <Input
                    id="exampleFormControlSelect1"
                    type="select"
                    value={searchBy}
                    style={{ height: "27px" }}
                    onChange={(e) => {
                      setSearchByValue("");
                      setSearchBy(e.target.value);
                    }}
                  >
                    <option value="mobile">Mobile</option>
                    <option value="name">Name</option>
                    <option value="ctid">CT ID</option>
                    <option value="branchId">Branch ID</option>
                    <option value="emiratesId">Emirates ID</option>
                    <option value="cardSerialNumber">Card Serial</option>
                  </Input>
                </FormGroup>
              </Col>
              <Col lg="2" className="form-input-padding">
                <FormGroup>
                  <label
                    className="form-control-label"
                    htmlFor="example3cols2Input"
                  >
                    Search for
                  </label>
                  <Input
                    id="example3cols2Input"
                    style={{ height: "27px" }}
                    placeholder={searchByValuePlaceholder}
                    type="text"
                    onKeyPress={(e) => e.charCode === 13 && handleFIlter(true)}
                    onChange={(e) =>
                      setSearchByValue(e.target.value && e.target.value)
                    }
                    value={searchByValue}
                  />
                </FormGroup>
              </Col>
              <Col lg="2" className="form-input-padding">
                <FormGroup>
                  <Label
                    className="form-control-label"
                    htmlFor="example3cols2Input"
                  >
                    From
                  </Label>
                  <DatePicker
                    format={customFormat}
                    placeholder="DD-MM-YY"
                    className="formcontrol-date"
                    onChange={(e, dateString) => {
                      if (dateString && dateString != "") {
                        setFromDate(moment(dateString, dateFormat));
                      } else {
                        setFromDate(null);
                      }
                    }}
                    value={fromDate}
                    // format={dateFormat}
                  />
                </FormGroup>
              </Col>
              <Col lg="2" className="form-input-padding">
                <FormGroup>
                  <Label
                    className="form-control-label"
                    htmlFor="example3cols2Input"
                  >
                    To
                  </Label>
                  <DatePicker
                    format={customFormat}
                    placeholder="DD-MM-YY"
                    className="formcontrol-date"
                    onChange={(e, dateString) => {
                      if (dateString && dateString != "") {
                        setToDate(moment(dateString, dateFormat));
                      } else {
                        setToDate(null);
                      }
                    }}
                    value={toDate}
                  />
                </FormGroup>
              </Col>
              <div
                lg="1"
                className="form-input-padding"
                style={{ marginTop: "2px" }}
              >
                <FormGroup>
                  <Label
                    className="form-control-label"
                    htmlFor="exampleFormControlSelect1"
                  >
                    Filter by
                  </Label>
                  <div>
                    <Button
                      style={{ width: "100%", height: "26px" }}
                      color="primary"
                      type="button"
                      id="example3cols2Input"
                      className="filter-button"
                      onClick={() => setModalShow(true)}
                    >
                      <div>
                        {" "}
                        <i className="fas fa-filter"></i>
                      </div>
                    </Button>
                  </div>
                </FormGroup>
                <span style={{ fontSize: 8 }}>
                  {filtersSelected && noOfFiltersSelected > 0 ? (
                    <>
                      <h6 style={{ display: "flex", alignItems: "center" }}>
                        Selected({noOfFiltersSelected}){" "}
                        {/* <i
                          class="fas fa-window-close"
                          onClick={() => resetFilter()}
                          style={{ cursor: "pointer", paddingLeft: "5px" }}
                        /> */}
                      </h6>
                    </>
                  ) : (
                    <></>
                  )}
                </span>
              </div>
              <Col
                lg="1"
                style={{ marginTop: "9px" }}
                className="form-input-padding"
              >
                <FormGroup>
                  <Label
                    className="form-control-label"
                    htmlFor="example3cols2Input"
                  ></Label>
                  <div>
                    <Button
                      type="button"
                      style={{
                        width: "100%",
                        background: "#e91d24",
                        color: "white",
                        height: "26px",
                        border: "1px solid rgb(233, 29, 36)",
                      }}
                      id="example3cols2Input"
                      className="filter-button"
                      onClick={() => handleFIlter(true)}
                      disabled={searchByValue.length < 3}
                    >
                      <div>
                        <i class="fas fa-search"></i>
                      </div>
                    </Button>
                  </div>
                </FormGroup>
              </Col>
              <Col
                lg="1"
                style={{ marginTop: "9px", padding: "0px 6px" }}
                className="form-input-padding"
              >
                <FormGroup>
                  <Label
                    className="form-control-label"
                    htmlFor="example3cols2Input"
                  ></Label>
                  <div>
                    <Button
                      color="light"
                      type="button"
                      style={{ width: "100%", height: "26px" }}
                      id="example3cols2Input"
                      className="filter-button"
                      onClick={() => resetFilter()}
                    >
                      <div
                        style={{
                          fontSize: "12px",
                        }}
                      >
                        <i class="fas fa-redo-alt 2px"></i> Reset
                      </div>
                    </Button>
                  </div>
                </FormGroup>
              </Col>
            </Row>
          </CardBody>
        </Card>

        <Row>
          <div className="col card-parent">
            <Card style={{ padding: "1.25rem 1.5rem" }}>
              {dataLoading ? (
                <div style={{ textAlign: "center" }}>
                  <Loading />
                </div>
              ) : (
                <>
                  <NkTable
                    dataexcal
                    filename={"All-User-List"}
                    data={allUserList}
                    rowOnClick={rowOnClick}
                    buttonRef={buttonRef}
                    type="alluser"
                    filterdata={filterForm}
                    onExcelClciked={() => onExcelClciked(filterForm)}
                    dataEXCEL={allUserListExcel}
                    columns={columns}
                    columnsCsv={columnsCsv}
                    pagination={pagination}
                    onPagechange={(page) => {
                      setFilterForm({
                        ...filterForm,
                        page: page,
                      });
                    }}
                    showSizeChanged={(pageSize) => {
                      setSizeShow(pageSize);
                      setFilterForm({
                        ...filterForm,
                      });
                    }}
                  />
                </>
              )}
            </Card>
          </div>
        </Row>
      </Container>
      <StatusSelect
        show={modalShow}
        onHide={() => setModalShow(false)}
        statusFilter={statusFilter}
        selectedOption={selectedOption}
        options={options}
        handleChange={handleChange}
        selectedChannelOption={selectedChannelOption}
        channelOptions={channelOptions}
        handleChannelChange={handleChannelChange}
        showChannelFilter={true}
        placeholder="Status"
      />
    </>
  );
};

export default AllUsersPresentational;
